import React from "react";
import { VstInput } from "vstui";
import { Button } from "@vitalsource/vstui";

export default class TemplatePresentation extends React.Component {
  constructor(props) {
    super(props);
    this.stopPropagation = e => {
      !this.props.value && e.stopPropagation();
    };
  }

  componentDidMount() {
    this.createDeck.addEventListener("click", this.stopPropagation);
    // The addEventListener looks to be related to the order of event trapping
    document
      .querySelector(".save-cancel-buttons button")
      .addEventListener("click", this.props.cancel);
  }

  componentWillUnmount() {
    this.createDeck.removeEventListener("click", this.stopPropagation);
    document
      .querySelector(".save-cancel-buttons button")
      .removeEventListener("click", this.props.cancel);
  }

  render() {
    const { onChange, onSubmit, value } = this.props;
    return (
      <div
        className={"deck"}
        ref={li => {
          this.createDeck = li;
        }}
        onClick={onSubmit}
      >
        <h3 className="offScreen">
          {i18n.t("reader.flashcards.create-edit-flashcard-deck")}
        </h3>
        <form
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <div className="create-deck-form">
            <VstInput
              id="create-deck"
              label={i18n.t("reader.flashcards.type-deck-name")}
              onChange={onChange}
              placeholder={i18n.t("reader.flashcards.type-deck-name")}
              value={value}
              maxLength="255"
            />
          </div>
          <div className="save-cancel-buttons">
            <Button type="button" color="neutral" naked>
              {i18n.t("base.cancel")}
            </Button>
            <Button type="submit" onClick={onSubmit}>
              {i18n.t("base.save")}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}
